// extracted by mini-css-extract-plugin
export var actionButtonsContainer = "_i4-0";
export var actionModalContentContainer = "_i4-1";
export var createTagButton = "_i4-2";
export var footerContainer = "_i4-7";
export var fullWidthDivider = "_i4-3";
export var hasCreateTagButton = "_i4-4";
export var noCreateTagButton = "_i4-5";
export var tagsContainer = "_i4-6";
export var tagsModalContentContainer = "_i4-8";